import { RssReaderCardType } from "../../../components/RssReader/RssReaderCard";
import { RssFetcher, RssSource } from "./types";
import { thwackBlogsJsonFetcher } from "./fetchers/thwackBlogsJsonFetcher";

const RSSService = () => {
  const fetchers: Map<RssSource, RssFetcher> = new Map([
    ["THWACK Blogs Json", thwackBlogsJsonFetcher()],
  ]);

  return {
    fetchData: async (
      source: RssSource,
      limit: number,
    ): Promise<RssReaderCardType[]> => {
      if (!source || source.trim() === "") {
        throw new Error("RSS source cannot be empty");
      }
      const fetcher = fetchers.get(source);
      if (!fetcher) {
        throw new Error(`Unsupported RSS source: ${source}`);
      }
      return fetcher.fetch(limit);
    },
  };
};

export default RSSService;
